import React from 'react';

import { Button, LinkButton } from '@eika/button';
import { WarningCard } from '@eika/card';
import { Loader } from '@eika/loader';

import useTranslation from '../../../../../../hooks/useTranslation';
import { DeleteSuccessModalContent } from '../../../Item/DeleteSuccess';
import { DeleteStatusProps } from '../../types';

const DeleteStatus: React.FC<DeleteStatusProps> = ({ status, onClose, onDelete }) => {
    const translated = useTranslation();
    switch (status) {
        case 'success':
            return <DeleteSuccessModalContent />;
        case 'error':
            return (
                <div className="component-group">
                    <WarningCard title={translated.errors.somethingWentWrong} isModal>
                        <p>{translated.outbox.deleteError}</p>
                        <p>{translated.outbox.errorContactUs}</p>
                        <div className="modal-body__buttons">
                            <LinkButton onClick={onClose}>{translated.cancel}</LinkButton>
                            <Button className="modal-body__button" buttonType="positive" onClick={onDelete}>
                                {translated.tryAgain}
                            </Button>
                        </div>
                    </WarningCard>
                </div>
            );
        case 'pending':
            return (
                <div className="outbox__centered">
                    <Loader />
                </div>
            );
        default:
            return null;
    }
};

export default DeleteStatus;
